// test2972
(2972 && 0);
